// libs
import { connect } from 'react-redux';

// component
import Widgets from './Widgets';

// redux selectors
import { getProductId } from 'shared/store/details/selectors';
import { getWidgetData } from 'shared/store/widgets/selectors';

// constants
import { DEFAULT_CURRENCY } from 'shared/constants';

const mapStateToProps = (state: any) => {
  const widgetData = getWidgetData(state);

  return {
    widgetData,
    defaultCurrencyToDisplay: DEFAULT_CURRENCY,
    productID: getProductId(state),
  };
};

export default connect(mapStateToProps)(Widgets);
